import React from 'react';

interface TabConfiguration {
    label: string;
    isActive: boolean;
    onToggle(string): void;
}

function SortTab({label, isActive, onToggle}: TabConfiguration) {
    /**
     * Respond to clicks on the tab button
     */
    const onTabClick = (evt: React.MouseEvent<HTMLButtonElement>) => {
        evt.preventDefault();

        onToggle(isActive ? '' : label);
    };

    return (
        <button
            id="filter-tab-sort-by"
            type="button"
            role="tab"
            aria-selected={isActive}
            aria-controls="filters-tab-sort-by-panel"
            className={`button button--tab body-size-xl ${isActive ? 'button--active' : ''}`}
            aria-expanded={isActive}
            onClick={onTabClick}
        >
            <div className={`icon__expand-container ${isActive && 'icon__expand--active'}`}>
                <svg className="icon__expand-horizontal">
                    <use xlinkHref="#minus"></use>
                </svg>
                <svg className="icon__expand-vertical">
                    <use xlinkHref="#minus"></use>
                </svg>
            </div>
            <span className="button__label">Sort by</span>
        </button>
    );
}

export default React.memo(SortTab);
